import { Navigate, Outlet } from 'react-router-dom';
import { PageLoader } from '@/layouts/components/PageLoader/PageLoader';
import { useOnboarding } from '@/features/onboarding';
import { routes } from '../routes';

// Email entry and confirmation are only for users without a validated email;
// opening them directly afterwards hands the user back to the wizard.
export const EmailGuard = () => {
  const { isOnboardingStateLoading, isEmailVerified } = useOnboarding(true);

  if (isOnboardingStateLoading) {
    return <PageLoader />;
  }

  if (isEmailVerified) {
    return <Navigate to={routes.wizard.base} replace />;
  }

  return <Outlet />;
};
